import { useTranslation } from 'react-i18next';

import {
  AddCircleLineIcon,
  Button,
  CloseCircleLineIcon,
  Col,
  Form,
  Row,
  SelectInput,
  Text,
  TextInput,
  Title,
} from 'ui';

export type ChoiceFormValues = {
  name: string;
};

export type QuestionFormValues = {
  choices: ChoiceFormValues[];
  multiple: boolean;
  question: string;
};

type P = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  defaultQuestion: any;
  maxLength?: number;
  name: string;
};

const PollQuestions = ({ defaultQuestion, maxLength = 90, name }: P) => {
  const { t } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const renderChoice = (field: any, removable: boolean, remove: (name: number) => void, autoFocus: boolean) => (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    <Row gutter={16} key={field.key}>
      <Col span={21}>
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
        <Form.Item<ChoiceFormValues> className="poll__question" key={field.key} required={false}>
          <TextInput
            input={{
              autoFocus,
              placeholder: t('Answer...'),
            }}
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            item={{
              ...field,
              hideLabel: true,
              label: 'Answer',
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              name: [field.name, 'name'],
              rules: [
                { required: true, whitespace: true },
                {
                  max: maxLength,
                },
              ],
            }}
          />
        </Form.Item>
      </Col>
      <Col className="poll__delete" span={3}>
        {removable ? (
          <Button
            icon={<CloseCircleLineIcon />}
            id="btn_delete-option"
            onClick={() => {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              remove(field.name);
            }}
            size="large"
          />
        ) : null}
      </Col>
    </Row>
  );

  const renderQuestion = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    field: any,
    removable: boolean,
    questionNumber: number,
    removeQuestion: (name: number) => void,
  ) => (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    <div key={`${field.name}-${questionNumber}`}>
      <div>
        <Title level={5} marginBottom>
          {t('Question')} #{questionNumber}
        </Title>
      </div>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
      <Form.Item<QuestionFormValues> className="poll" key={field.key} required={false}>
        <Row className="poll__question-wrapper" gutter={16}>
          <Col span={14}>
            <TextInput
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              item={{
                ...field,
                label: 'Question',
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
                name: [field.name, 'question'],
                rules: [
                  { required: true, whitespace: true },
                  {
                    max: maxLength,
                  },
                ],
              }}
            />
          </Col>
          <Col span={7}>
            <SelectInput
              input={{
                'data-test-id': 'poll_type',
                getOptionLabel: (option) => option.name,
                getOptionValue: (option) => option.value,
                options: [
                  {
                    name: t('Single choice'),
                    value: false,
                  },
                  {
                    name: t('Multiple choice'),
                    value: true,
                  },
                ],
                placeholder: t('Select type'),
              }}
              item={{
                label: 'Type',
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
                name: [field.name, 'multiple'],
                rules: [
                  {
                    required: true,
                  },
                ],
              }}
            />
          </Col>
          <Col className="poll__delete" span={3}>
            {removable ? (
              <CloseCircleLineIcon
                className="poll__delete__button"
                id="btn_delete-question"
                onClick={() => {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
                  removeQuestion(field.name);
                }}
              />
            ) : null}
          </Col>
        </Row>
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
        <Form.List name={[field.name, 'choices']}>
          {(fields, { add, remove: removeChoice }) => {
            const first = fields[0];
            const rest = fields.slice(1);
            return (
              <div className="poll__answers-wrapper">
                <div className="poll__answers-title">
                  <Text weight="bold">Answers</Text>
                </div>
                {renderChoice(first, fields.length > 1, removeChoice, false)}
                {rest.map((choiceField) => renderChoice(choiceField, true, removeChoice, true))}
                <Form.Item<ChoiceFormValues>>
                  <Button
                    icon={<AddCircleLineIcon />}
                    id="poll_add-option"
                    onClick={() => {
                      add();
                    }}
                    size="large"
                    type="secondary"
                  >
                    Add option
                  </Button>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
      </Form.Item>
    </div>
  );

  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => {
        const first = fields[0];
        const rest = fields.slice(1);

        return (
          <div>
            {renderQuestion(first, fields.length > 1, 1, remove)}
            {rest.map((field, index) => renderQuestion(field, true, index + 2, remove))}
            <Form.Item<QuestionFormValues> className="poll__add-question">
              <Button
                icon={<AddCircleLineIcon />}
                id="btn_add-question"
                onClick={() => {
                  add(defaultQuestion);
                }}
                size="large"
              >
                Add new question
              </Button>
            </Form.Item>
          </div>
        );
      }}
    </Form.List>
  );
};

export default PollQuestions;
